import React, { useEffect, useRef, useState } from "react";
import { SERVER_URL } from "../../config/config";
import Loader from "../Loader";

export default function EWBErros({ searchTerm }) {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    try {
      const res = await fetch(SERVER_URL + "/tie_details/company_details", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          paginate: { number_of_rows: 100, page_number: 1 },
          filter_fields: {},
        }),
      });

      const data = await res.json();
      if (data && data.company && Array.isArray(data.company[1])) {
        setCompanies(data.company[1]);
      }
    } catch (err) {
      console.error("Company fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  const safeLower = (v) => (typeof v === "string" ? v.toLowerCase() : "");

  const display = (v) =>
    v !== null && v !== undefined && v !== "" ? v : "—";

  const getTotalErrorCount = (company) =>
    Array.isArray(company.not_extended_error_wise)
      ? company.not_extended_error_wise.reduce(
          (sum, e) => sum + (Number(e.count) || 0),
          0
        )
      : 0;

  const filteredCompanies = companies
    .filter((c) => {
      const search = safeLower(searchTerm);
      return (
        safeLower(c.company_name).includes(search) ||
        safeLower(c.gst_no).includes(search)
      );
    })
    .sort((a, b) => getTotalErrorCount(b) - getTotalErrorCount(a));

  if (loading) return <Loader text="Loading EWB errors..." />;

  return (
    <div className="company-grid">
      {filteredCompanies.map((company) => {
        const totalErrors = getTotalErrorCount(company);
        const hasErrors = totalErrors > 0;

        return (
          <div
            key={company.id}
            className={
              "company-card " + (hasErrors ? "alert-red" : "alert-green")
            }
          >
            <div className="card-header">
              <h3>{company.company_name.toUpperCase()}</h3>

              <span
                className={
                  "health-pill " + (hasErrors ? "health-red" : "health-green")
                }
              >
                {hasErrors ? totalErrors : "0"}
              </span>
            </div>

            <div className="company-summary">
              <div>
                <span>GST</span>
                {display(company.gst_no)}
              </div>

              <div>
                <span>Contact</span>
                {display(company.contact_no)}
              </div>

              <div>
                <span>Address</span>
                {display(company.address)}
              </div>

              <div>
                <span>EWB Used</span>
                {display(company.current_ewb_count)}
              </div>

              <div>
                <span>EWB Limit</span>
                {display(company.allowed_ewb_count)}
              </div>

              <div>
                <span>Fetched Today</span>
                {display(company.today_eway_bill_count)}
              </div>
            </div>

            {hasErrors && (
              <div className="usage-box">
                <div className="usage-title error-title">Errors</div>

                {company.not_extended_error_wise.map((err, idx) => (
                  <div key={idx} className="error-row">
                    <span>{String(err.error)}</span>
                    <strong>{err.count}</strong>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
